import React, { useEffect } from 'react';

const ShippingPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="section aboutPage pt-5 pb-5">
            <div className="container">
                <h1 className="hd mb-4">Shipping Policy</h1>
                <div className="content">
                    <h3>Processing Time</h3>
                    <p>All orders are processed and delivered within 2-3 business days. Orders are not shipped or delivered on weekends or holidays.</p>
                    <p>If we are experiencing a high volume of orders, shipments may be delayed by a few days. Please allow additional days in transit for delivery. If there will be a significant delay in the shipment of your order, we will contact you via email or phone.</p>

                    <h3>Shipping Time</h3>
                    <p><strong>Domestic Shipping:</strong> Orders will be delivered within 3 to 4 days from the date of order confirmation.</p>
                    <p>Please note that delivery times may be affected by factors beyond our control, such as weather conditions, customs delays, and other unforeseen circumstances.</p>

                    <h3>Shipment Confirmation & Order Tracking</h3>
                    <p>You will receive a Shipment Confirmation email once your order has shipped containing your tracking number(s). The tracking number will be active within 24 hours.</p>

                    <h3>Customs, Duties and Taxes</h3>
                    <p>Paymond Services Private Limited is not responsible for any customs and taxes applied to your order. All fees imposed during or after shipping are the responsibility of the customer (tariffs, taxes, etc.).</p>

                    <h3>Damages</h3>
                    <p>Paymond Services Private Limited is not liable for any products damaged or lost during shipping. If you received your order damaged, please contact the shipment carrier to file a claim.</p>
                    <p>Please save all packaging materials and damaged goods before filing a claim.</p>
                </div>
            </div>
        </section>
    );
};

export default ShippingPolicy;
